export const all_routes = {
  // - - - Routes avaible to all

  comingsoon: "/coming-soon",
  undermaintenance: "/under-maintenance",
  signin: "/signin",
  forgotPassword: "/forgot-password",

  // - - - Routes avaible to all but data will be shown based on role
  // dashboard: "/",
  newdashboard: "/index",
  profile: "/profile",

  // - - Routes Available to Admin
  partlist: "/part-list",
  categorylist: "/category-list",
  customerlist: "/customer-list",
  transportlist: "/transport-list",
  product: "/product",
  brandlist: "/brand-list",
  addpart: "/add-part",
  inventory: "/inventory",
  addcategory: "/add-category",
  addcustomer: "/add-customer",
  addtransport: "/add-transport",
  adduser: "/add-user",
  managestock: "/manage-stocks",
  lowstock: "/low-stocks",
  allorder: "/all-orders",
  neworders: "/new-orders",
  invoice: "/invoice",
  invoicedetails: "/invoice-details",
  salesreturn: "/sales-returns",
  addcatelog: "/add-catelog",
  cateloglist: "/catelog-list",
  addpartsmodels: "/add-parts-models",
  editpartsmodels: "/edit-parts-models",
  partsmodels: "/parts-models",

  // Reports
  salesreport: "/sales-report",
  purchasereport: "/purchase-report",
  inventoryreport: "/inventory-report",
  customerreport: "/customer-report",
  productreport: "/product-report",
  productexpiredreport: "/product-expiry-report",
  productquantityreport: "/product-quantity-report",
  expensereport: "/expense-report",
  incomereport: "/income-report",
  taxreport: "/tax-report",
  profitloss: "/profit-loss-report",
  vendorreport: "/vendor-report",
  // Reports

  //Enquiries
  serviceenquiry: "/service-enquiry",
  customernquiry: "/franchise-enquiry",

  stockhistory: "/stock-history",
  soldstock: "/sold-stock",
  activities: "/activities",
  accounting: "/accounting",
  addvendors: "/add-vendors",
  addstocks: "add-stock",
  purchaseorder: "purchase-order",
  discounts: "/discounts",
  stockissue: "/stock-issue",
  orderhistory: "/order-history",

  // POS Routes
  pos: "/pos",

  // HRMS Routes
  employee: "/employees",
  addemployee: "/add-employee",
  editemployee: "/edit-employee",
  employeelist: "/employee-list",
  department: "/department",
  departmentlist: "/department-list",
  attendanceemployee: "/attendance-employee",
  attendanceadmin: "attendance-admin",
  designation: "/designation",
  shift: "/shift",
  payslip: "/payslip",
  holidays: "/holidays",
  leavesadmin: "leaves-admin",
  leavesemployee: "/leaves-employee",
  leavestype: "/leave-types",
  payrollList: "/employee-salary",
};
